<template>
  <main class="container my-5 mainError">
    <h1 class="display-5">Error 404</h1>
    <button
      type="button"
      class="btn btn-outline-primary"
      @click="$router.go(-2)"
    >
      {{ $store.state.language.skip }}
    </button>

    <hr class="" />
    <!-- <h2>Seite nicht gefunden {{ $route.params.error }}</h2> -->
    <h2>{{ $store.state.language.notFound }}</h2>
  </main>
</template>

<script>
export default {
  name: "NotFound",
  metaInfo: {
    title: "NotFound",
    titleTemplate: "%s | Mobile Tech Zone",
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.utils.loaded = true;
    });
  },

  methods: {},
};
</script>
